module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Roman.d7c19548.svg";